import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { SpecialFileType } from '@/shared/constant/SpecialFileType';
import trimEnd from 'lodash-es/trimEnd';
import React from 'react';

export function useGenerateSpecialFileLink() {
  const selectedSidebarTreeNode = useDocsDataModelStore(
    (x) => x.sidebarTree.selectedSidebarTreeNode,
  );
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const homeLink = useDocsDataModelStore((x) => x.sidebarTree.homeLink);
  const originHost = 'http://test.com';

  const markdownSpecialFileLink = React.useMemo(() => {
    if (!selectedSidebarTreeNode?.to) {
      return undefined;
    }
    const url = new URL(selectedSidebarTreeNode.to, originHost);
    url.pathname += SpecialFileType.MD;

    return url.toString().substring(originHost.length);
  }, [selectedSidebarTreeNode]);

  const llmsSpecialFileLink = React.useMemo(() => {
    if (!homeLink) {
      return undefined;
    }
    const url = new URL(homeLink, originHost);
    url.pathname = trimEnd(url.pathname, '/') + '/' + SpecialFileType.LLMSTxt;

    return url.toString().substring(originHost.length);
  }, [homeLink]);

  const [queryPrompt, setQueryPrompt] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    const link = markdownSpecialFileLink ?? window.location.href;
    const url = new URL(link, window.location.origin);

    setQueryPrompt(
      clientI18n('specialFile.menu.gpt.prompt', {
        link: url.toString(),
      }),
    );
  }, [clientI18n, markdownSpecialFileLink]);

  const chatGPTOpenLink = React.useMemo(() => {
    if (!queryPrompt) {
      return undefined;
    }
    return IS_GLOBAL
      ? `https://chat.openai.com/?hints=search&q=${encodeURIComponent(queryPrompt)}`
      : undefined;
  }, [queryPrompt]);

  const claudeOpenLink = React.useMemo(() => {
    if (!queryPrompt) {
      return undefined;
    }
    return IS_GLOBAL ? `https://claude.ai/new?q=${encodeURIComponent(queryPrompt)}` : undefined;
  }, [queryPrompt]);

  return {
    markdownSpecialFileLink,
    llmsSpecialFileLink,
    chatGPTOpenLink,
    claudeOpenLink,
  };
}
